import {
    FETCH_SHOPPING_CART_REQUEST,
    FETCH_SHOPPING_CART_SUCCESS,
    FETCH_SHOPPING_CART_FAILURE,
} from '../actions/shoppingCartActions';

const initialState = {
    data: [],
    loading: false,
    error: null,
};

const shoppingCartReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SHOPPING_CART_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case FETCH_SHOPPING_CART_SUCCESS:
            return {
                ...state,
                data: action.payload.data,
                loading: false,
                error: null,
            };
        case FETCH_SHOPPING_CART_FAILURE:
            return {
                ...state,
                data: [],
                loading: false,
                error: action.payload.error,
            };
        default:
            return state;
    }
};

export default shoppingCartReducer;
